<template>
    <div class="card">
        <div class="card-header">Optionen für die automatische Bepreisung</div>
        <div class="card-body">
            <b-form-group>
                <b-form-checkbox-group
                    v-model="roundingOptions"
                    name="pricingOptions"
                    :options="options"
                />
            </b-form-group>
            <b-form-group>
                <b-form-radio-group
                    id="btnradios1"
                    v-model="roundingType"
                    buttons
                    button-variant="outline-primary"
                    size="sm"
                    :options="type"
                    name="round"
                />
            </b-form-group>
            <b-input-group size="sm" class="mb-3" prepend="Preis von - bis: " append="€">
                <NumberInput
                    id="price-from"
                    v-model.number.trim="priceFrom"
                    name="price-from"
                    placeholder="0,00"
                />

                <NumberInput
                    id="price-to"
                    v-model.number.trim="priceTo"
                    name="price-to"
                    placeholder="0,00"
                    :state="priceFromToError ? false : null"
                    @blur="checkPriceRangeOnBlur"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import NumberInput from "@/components/widgets/NumberInput";
export default {
    name: "Autobepreisungoptions",
    components: { NumberInput },
    data: function() {
        return {
            options: [
                { text: "0,09", value: 0.09 },
                { text: "0,19", value: 0.19 },
                { text: "0,29", value: 0.29 },
                { text: "0,39", value: 0.39 },
                { text: "0,49", value: 0.49 },
                { text: "0,59", value: 0.59 },
                { text: "0,69", value: 0.69 },
                { text: "0,79", value: 0.79 },
                { text: "0,89", value: 0.89 },
                { text: "0,99", value: 0.99 }
            ],
            type: [
                { text: "aufrunden", value: "aufrunden", default: true },
                { text: "abrunden", value: "abrunden" }
            ],
            priceFromToError: false
        };
    },
    computed: {
        roundingOptions: {
            get() {
                return this.$store.state.pricingOptions.roundingOptions;
            },
            set(value) {
                this.$store.commit("setRoundingOptions", value);
            }
        },
        roundingType: {
            get() {
                return this.$store.state.pricingOptions.roundingType;
            },
            set(value) {
                this.$store.commit("setRoundingType", value);
            }
        },
        priceFrom: {
            get() {
                return this.$store.state.pricingOptions.priceFrom;
            },
            set(value) {
                // should only happen on blur, not on key-up
                this.$store.commit("setPriceFrom", value);
            }
        },
        priceTo: {
            get() {
                return this.$store.state.pricingOptions.priceTo;
            },
            set(value) {
                //todo error checking if priceFrom is lower
                this.$store.commit("setPriceTo", value);
            }
        }
    },

    watch: {
        priceFrom: {
            handler: "checkPriceRange"
        },
        priceTo: {
            handler: "checkPriceRange"
        }
    },
    created() {
        // sets the first roundingType as default
        if (!this.roundingType) {
            this.roundingType =
                this.type.length > 0 && this.type[0].value ? this.type[0].value : null;
        }
    },
    methods: {
        checkPriceRange() {
            if (this.priceTo && this.priceFrom > this.priceTo) {
                this.priceFromToError = true;
            } else {
                this.priceFromToError = false;
            }
        },
        checkPriceRangeOnBlur() {
            if (this.priceTo && this.priceFrom > this.priceTo) {
                console.error("Preis kleiner Preis größer");
                this.priceTo = null;
            }
        }
    }
};
</script>

<style scoped>
.card-body > label {
    margin-top: 8px;
    margin-bottom: 0px;
}
</style>
